import { useAppSelector } from '../../hooks';

export const useSearchSelector = () => {
    return useAppSelector(state => state.search);
};
